import React from 'react';
import datenschutzContent from '../data/datenschutzData';
import PageWrapper from "../components/PageWrapper";

const Datenschutz = () => {
    return (
        <PageWrapper>

            <div
                className="py-12 sm:py-16 min-h-screen"
                style={{
                    backgroundImage: `url('/gradient_bg.svg'), linear-gradient(to bottom, #0ea5e9, #ffffff 50%, #ffffff)`,
                    backgroundRepeat: "no-repeat, no-repeat",
                    backgroundSize: "cover, cover",
                    backgroundPosition: "center, center",
                }}
            >
                <div className="mx-auto max-w-6xl lg:max-w-6xl px-6 sm:px-6 lg:px-4">
                    <div className="grid grid-cols-1 lg:grid-cols-10 gap-8 items-start">
                        <div className="space-y-4 text-gray-700 leading-relaxed lg:col-span-6">
                            <h1 className="text-sky-900 font-semibold text-xl md:text-2xl md:leading-tight font-heading">{datenschutzContent.title}</h1>

                            <p className="mb-4 font-body text-base sm:text-lg">{datenschutzContent.intro}</p>

                            {datenschutzContent.sections.map((section, index) => (
                                <div key={index}>
                                    <h2 className="text-xl font-extrabold mt-8 mb-2 font-heading">{section.heading}</h2>
                                    <p className="mb-4 font-body text-base sm:text-lg">{section.text}</p>
                                </div>
                            ))}

                            <p className="text-sm text-gray-500 mt-8 font-body">
                                {datenschutzContent.lastUpdated}
                            </p>
                        </div>
                        <div className="lg:col-span-4">
                            <div className="relative w-full h-full rounded-xl group">
                                <img
                                    className="relative z-10 w-full h-full object-cover rounded-xl shadow-xl "
                                    src="/Mitgliedschaft/1.webp"
                                    alt="Angelfreunde 1866"
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </PageWrapper>
    );
};

export default Datenschutz;
